import React, { useState, useEffect } from "react";
import mobileImage from "../Image/Mobile-screen-image.png";
import { useTranslation } from "react-i18next";
import AppStore from '../Image/Play-Store.png'
import PlayStore from '../Image/App-Store.png'

const DownloadApp = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector(".download-app-desk");
      const rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom >= 0) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section className="application pt-5 p-lg-0">
        <div className="container">
          <div className="row">
            <div
              className="col-sm-12 col-md-6 p-0 px-lg-0 px-md-0 px-3 download-app-desk align-self-center text-lg-start text-md-start text-center"
              style={{
                opacity: isVisible ? 1 : 0,
                animation: isVisible ? "fadeIn 1s forwards" : "none",
              }}
            >
              <p className="DownloadappTxt1 pb-0">{t("download_app.title")}</p>
              <h2
                className="DownloadappTxt2"
                dangerouslySetInnerHTML={{
                  __html: t("download_app.heading"),
                }}
                style={{
                  opacity: isVisible ? 1 : 0,
                  animation: isVisible ? "fadeIn 1s forwards" : "none",
                }}
              />
              <p className="DownloadappTxt3 mb-4 mt-3">
                {t("download_app.subheading")}
              </p>
              <div className="mb-lg-0 mb-3">
                <a
                  href="https://play.google.com/store/apps/details?id=com.nitya.mala.app"
                  className=""
                >
                  <img
                    src={AppStore}
                    width="150px"
                    alt="app_store"
                  />
                </a>
                <a
                  href="https://apps.apple.com/app/nitya-mala/id6740871116"
                  className="d-inline-block"
                >
                  <img
                    src={PlayStore}
                    width="150px"
                    alt="play_store"
                  />
                </a>
              </div>
            </div>
            <div
              className="col-sm-12 col-md-6 align-self-end"
              style={{
                opacity: isVisible ? 1 : 0,
                animation: isVisible ? "zoomIn 1s forwards" : "none",
              }}
            >
              <img
                src={mobileImage}
                alt="mobileImage"
                className="mobileImage"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DownloadApp;
